import type { FindUserReservationFlightReservation } from "@/app/lib/types/codegen";
import { useTranslations } from "use-intl";
import { ReservationPaymentDetails } from "./ReservationPaymentDetails";
import { ReservationNextSteps } from "./ReservationNextSteps";
import { ReservationDocumentList } from "../ReservationDocumentList";
import { type ReservationStatus } from "@/app/lib/types/types";
import { OrderStatusSection } from "../OrderStatusSection";
import { FlightReservationSegmentsData } from "../FlightReservationSegmentsData";

type Props = {
  status: ReservationStatus;
  reservation: FindUserReservationFlightReservation;
};

export const MyFlight = ({ status, reservation }: Props) => {
  const t = useTranslations();

  return (
    <>
      <OrderStatusSection status={status} />

      <FlightReservationSegmentsData
        itinerary={reservation.externalReservation}
      />

      <section className="section-card mt-2 mb-4 flex w-full items-center justify-between gap-4">
        <span className="section-title mb-0">{t("flights.ticketNumber")}</span>
        <span className="text-base font-semibold text-text-title">
          {reservation.externalReservation.reference.external}
        </span>
      </section>

      <ReservationDocumentList reservationId={reservation.reservationId} />

      <section>
        <h3 className="section-title mt-4">{t("flights.passengerList")}</h3>
        <ul
          className="section-card flex w-full flex-col gap-4"
          data-sentry-mask
        >
          {reservation.externalReservation.travelers.map((traveler) => (
            <li
              className="text-text-title"
              key={`${traveler.firstName}${traveler.lastName}`}
            >
              {traveler.firstName} {traveler.lastName}
            </li>
          ))}
        </ul>
      </section>

      <ReservationPaymentDetails reservation={reservation} />
      <ReservationNextSteps type="flight" />
    </>
  );
};
